import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const userDataImporterSelectors = importerSelectors(
  'userData.importer',
);

export default userDataImporterSelectors;
